var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.3741,
    height: 29,
    rx: 5,
    fill: "#FFA011",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_15833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4771 18.0104L16.0771 8.67707C15.5437 7.74374 14.2771 7.41041 13.3437 7.94374C13.0104 8.14374 12.7437 8.41041 12.6104 8.67707L7.2104 18.0104C6.67707 18.9437 7.0104 20.2104 7.94374 20.7437C8.27707 20.9437 8.6104 21.0104 8.94374 21.0104H19.6771C20.8104 21.0104 21.6771 20.0771 21.6771 19.0104C21.7437 18.6104 21.6104 18.2771 21.4771 18.0104ZM14.3437 18.3437C13.9437 18.3437 13.6771 18.0771 13.6771 17.6771C13.6771 17.2771 13.9437 17.0104 14.3437 17.0104C14.7437 17.0104 15.0104 17.2771 15.0104 17.6771C15.0104 18.0771 14.7437 18.3437 14.3437 18.3437ZM15.0104 15.0104C15.0104 15.4104 14.7437 15.6771 14.3437 15.6771C13.9437 15.6771 13.6771 15.4104 13.6771 15.0104V12.3437C13.6771 11.9437 13.9437 11.6771 14.3437 11.6771C14.7437 11.6771 15.0104 11.9437 15.0104 12.3437V15.0104Z",
    fill: "#FFA011"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_15833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6.34375 6.34375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2d4bf66c884eec1f351d948d5bbebe03.svg";
export { ForwardRef as ReactComponent };